module.exports = __webpack_public_path__ + "img/login-background-bk.9446891b.png";